import Input from "../../../Medicine-master/Component/Input";

export const TestOrderInputs = [
  {
    tag: Input,
    img: "",
    label: "Patient Name",
    name: "patientName",
    validation: "required",
    required: true,
    key: "patientName",
  },
  {
    tag: Input,
    img: "",
    label: "Test",
    name: "testName",
    validation: "required",
    required: true,
    key: "testName",
  },
  // {
  //   tag: Input,
  //   img: "",
  //   label: "Price(₹)",
  //   name: "price",
  //   validation: "required",
  //   required: true,
  //   key: "price",
  // },
  {
    tag: Input,
    img: "",
    label: "Priority level",
    name: "priorityLevel",
    validation: "required",
    required: true,
    key: "priorityLevel",
  },
  {
    tag: Input,
    img: "",
    label: "Instructions",
    name: "instruction",
    validation: "required",
    required: true,
    key: "instruction",
  },
];
